export default {
    edge_tensor_video_review_title: "Revisión de Video",
    edge_tensor_video_review_video: "Video",
    edge_tensor_video_review_notes: "Notas",
    edge_tensor_video_review_status: "Estado",
    edge_tensor_video_review_warning_notes: "Las notas deben tener al menos 3 caracteres",
    edge_tensor_video_review_success_messages: "Revisión de video guardada con éxito",
    edge_tensor_video_review_error_messages: "Error al guardar la revisión de video",
    edge_tensor_video_review_unreviewed: "No revisado",
    edge_tensor_video_review_reviewed: "Revisado",
    edge_tensor_video_review_false_positive: "Falso Positivo",
    edge_tensor_video_review_accepted: "Aceptado",
    edge_tensor_video_review_disputed: "Disputado", 
    edge_tensor_video_review: "Revisión",
    edge_tensor_video_review_video_results: "Revisión de IA",
    edge_tensor_video_review_video_result: "Resultado de Video",
    edge_tensor_video_review_event_video: "Evento de Video"
};